import React from "react";
import "./ExploreCategories.css";
import CommonHeadingAfterLine from "../../Common-Component/CommonHeadingAfterLine/CommonHeadingAfterLine";
import { Link } from "react-router-dom";
import Homepage_common_heading from "../../Common-Component/Homepage_common_heading/Homepage_common_heading";

const ExploreCategories = ({ subcategory }) => {
  const categories = [
    {
      image: "/assets/Images/Home/explore_category/img1.png",
      title: "Business Cards",
    },
    {
      image: "/assets/Images/Home/explore_category/img2.png",
      title: "Stickers & Label",
    },
    {
      image: "/assets/Images/Home/explore_category/img3.png",
      title: "Caps",
    },

    {
      image: "/assets/Images/Home/explore_category/img4.png",
      title: "Corporate Gifts",
    },

    {
      image: "/assets/Images/Home/explore_category/img5.png",
      title: "Stickers & Label",
    },

    {
      image: "/assets/Images/Home/explore_category/img6.png",
      title: "Banner Works",
    },

    {
      image: "/assets/Images/Home/explore_category/img1.png",
      title: "Photo Gifts",
    },
    {
      image: "/assets/Images/Home/explore_category/img7.png",
      title: "Awards",
    },

    {
      image: "/assets/Images/Home/explore_category/img5.png",
      title: "Banner Works",
    },
    {
      image: "/assets/Images/Home/explore_category/img5.png",
      title: "Banner Works",
    },
  ];

  return (
    <section className="ExploreCategories">
      <div className="custom_container">
        {/* <CommonHeadingAfterLine headingText={"Explore by Categories"} /> */}
        <Homepage_common_heading headingText={"Explore by Categories"} headingDescText={"Discover custom products made for your brand."}/>

        <div className="cateogry_cards_holder">
          <div className="row">
            {subcategory?.map((item) => {
              return (
                <div className="col-lg-3 col-md-4 col-sm-6 col-12 custom-col">
                  <Link
                    className="product_img_holder"
                    to={`/visiting-cards?subcategory=${encodeURIComponent(
                      item?.name,
                    )}&sub_category_id=${item?.id}&image=${item?.image}`}
                  >
                    <div className="category_card">
                      <div className="row">
                        <div className="col-md-8 col-8">
                          <div className="product_title_div">
                            <p className="title">{item?.name}</p>
                            <p>Designed for daily organization.</p>
                          </div>
                        </div>
                        <div className="col-md-4 col-4">
                          <div className="product_img_holder">
                            <img
                              src={process.env.REACT_APP_IMG_URL + item?.image}
                              className="product_img"
                              alt="product_img"
                            />
                          </div>
                        </div>
                      </div>
                      {/* <Link
                      className="product_img_holder"
                      to={`/visiting-cards?subcategory=${encodeURIComponent(
                        item?.name
                      )}&sub_category_id=${item?.id}`}
                    >
                      <Orange_Round_Arrow_Btn btn_name="Shop Now" />
                    </Link> */}
                    </div>
                  </Link>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ExploreCategories;
